import RoundedButton from '../buttons/RoundedButton'
import Modal from '@mui/material/Modal'
import close from '../../assets/close.png'

const ConfirmModal = (props) => {
    return (
        <Modal
            className='flex items-center justify-center'
            disableAutoFocus={true}
            open={props.open}
            onClose={props.onClose}
        >
            <div className='bg-white justify-center items-center mx-4 pb-8 pt-6 rounded-[0.625rem] w-[34rem]'>

                <div className='flex flex-row justify-between items-center px-6'>
                    <p className='font-montserrat font-semibold text-accent'>{props.title}</p>
                    <button onClick={props.onClose}>
                        <img className='h-3 w-3 ' src={close} alt='Fechar'/>
                    </button>
                </div>

                <div className='h-px bg-neutral3 my-4'/>
                
                <p className='font-montserrat mt-3 px-6'>{props.message}</p>

                <div className='flex flex-row justify-center mt-8 px-6'>
                    <div className='flex w-60 me-6'>
                        <RoundedButton 
                            onClick={props.onClose}
                            text={props.buttonText1}
                            height={48}
                            bgColor='#E85F5C'
                        />
                    </div>

                    <div className='flex w-60'>
                        <RoundedButton 
                            onClick={props.onClick}
                            text={props.buttonText2}
                            height={48}
                            bgColor='#007EB4'
                        />
                    </div>  
                </div>
                
            </div>
        </Modal>
    )
}

export default ConfirmModal